import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import EditorActionCreators from "../actions/EditorActionCreators";
import UserStore from "../stores/UserStore";
import EditorStore from "../stores/EditorStore";
import JSONUtils from "../utils/JSONUtils";
import AssetStore from "../stores/AssetStore";
import LeftMenuStore from "../stores/LeftMenuStore";
import Dexie from "dexie";
import { ReactComponent as UploadedImage } from "../images/editor/uploaded_images_icon.svg";
import { ReactComponent as DropboxImage } from "../images/editor/Dropbox_Icon.svg";
import { ReactComponent as UploadsImage } from "../images/editor/uploads.svg";
import { ReactComponent as AIImage } from "../images/editor/ai_maker_icon.svg";
import { ReactComponent as CloseSVG } from "../images/editor/close_x.svg";

function getStateFromStores() {
  return {
    isPro: UserStore.isPro(),
    cutoutData: UserStore.getCutouts(),
    projectAssetData: UserStore.getProjectAssets(),
  };
}

const PickerMenu = () => {
  const [storesData, setStoresData] = useState(getStateFromStores());

  useEffect(() => {
    AssetStore.addChangeListener(_onChange);
    UserStore.addChangeListener(_onChange);
    LeftMenuStore.addChangeListener(_onChange);
    return () => {
      AssetStore.removeChangeListener(_onChange);
      UserStore.removeChangeListener(_onChange);
      LeftMenuStore.removeChangeListener(_onChange);
    };
  }, []);

  const _cancelClick = (event) => {
    event.preventDefault();
    EditorActionCreators.ShowFilePicker(false);
  };

  const _computerClick = (event) => {
    let fileSelect = document.getElementById("s_file");
    if (EditorStore.getFilePickerTool() === "collage") {
      fileSelect = document.getElementById("s_files");
    }
    fileSelect.addEventListener("change", onComputerClick);
    fileSelect.click();
  };

  const onComputerClick = async () => {
    let fileSelect;
    if (EditorStore.getFilePickerTool() === "collage") {
      fileSelect = document.getElementById("s_files");
      EditorStore.setShowSpinner(true);
      if (fileSelect && fileSelect.files && fileSelect.files.length > 0) {
        let hotspots = [];
        let bo = window.editor.getBaseObject();
        for (let y = 0; y < bo.children.length; y++) {
          if (bo.children[y].collagePlaceholder) {
            let found = false;
            for (let z = 0; z < bo.children[y].children.length; z++) {
              if (bo.children[y].children[z].CollageBackground) {
                found = true;
              }
            }
            if (
              !found &&
              bo.children[y] !== window.editor.getCollageSpotSelected()
            ) {
              hotspots.push(bo.children[y]);
            }
          }
        }
        if (window.editor.getCollageSpotSelected()) {
          hotspots.push(window.editor.getCollageSpotSelected());
        }
        let saveScale =
          window.editor.getOriginalSize().width /
          window.editor.getRenderer().view.width;
        for (let x = 0; x < fileSelect.files.length; x++) {
          (function (file) {
            let reader = new FileReader();
            reader.onloadend = function () {
              let hs = hotspots.pop();
              if (hs) {
                let maxSize =
                  (hs.width * saveScale + hs.height * saveScale) * 2;
                if (maxSize > 7000) maxSize = 7000;
                window.editor.loadTextureFromUrl(
                  reader.result,
                  function (texture) {
                    let id = JSONUtils.guid();
                    window.editor.addCollageBackground(texture, id, hs);
                  },
                  maxSize
                );
              }
            };

            if (file) {
              reader.readAsDataURL(file);
            }
          })(fileSelect.files[x]);
        }
        EditorActionCreators.ShowFilePicker(false);
      }
    } else {
      fileSelect = document.getElementById("s_file");
      if (fileSelect && fileSelect.files && fileSelect.files.length > 0) {
        let file = fileSelect.files[0];

        let reader = new FileReader();
        reader.onloadend = function () {
          if (file.name.endsWith(".pizap")) {
            window.editor.import(reader.result);
          } else {
            window.editor.addPicture(reader.result);
          }
          EditorActionCreators.ShowFilePicker(false);
        };

        if (file) {
          if (file.name.endsWith(".pizap")) {
            reader.readAsText(file);
          } else {
            reader.readAsDataURL(file);
          }
        }
      }
    }
  };

  const _backgroundClick = () => {
    let folders = AssetStore.getFeaturedBackgrounds();
    if (folders && folders.length > 0) AssetStore.setSelectedItem(folders[0]);
    EditorActionCreators.SetPickerState("background");
  };

  const AIClick = () => {
    EditorActionCreators.SetPickerState("ai_image");
  };

  const _cutoutClick = (event) => {
    EditorActionCreators.SetPickerState("cutout");
  };
  const _assetsClick = (event) => {
    EditorActionCreators.SetPickerState("projectAssets");
  };

  // const _facebookClick = (event) => {
  //   try {
  //     window.FB.getLoginStatus(function (response) {
  //       if (response.status === "connected") {
  //         window.FB.api("/me/permissions", function (response) {
  //           console.log("permissions returned");
  //           let found_perm = false;
  //           if (response && response.data) {
  //             for (let i = 0; i < response.data.length; i++) {
  //               if (response.data[i].permission === "user_photos") {
  //                 found_perm = true;
  //               }
  //             }
  //           }
  //           if (!found_perm) {
  //             window.FB.login(
  //               function (response) {
  //                 //LeftMenuActionCreators.getFacebookFolders();
  //                 EditorActionCreators.SetPickerState("facebook");
  //               },
  //               { scope: "email,user_photos" }
  //             );
  //           } else {
  //             //LeftMenuActionCreators.getFacebookFolders();
  //             EditorActionCreators.SetPickerState("facebook");
  //           }
  //         });
  //       } else if (response.status === "not_authorized") {
  //         console.log("not authorized");
  //         window.FB.login(
  //           function (response) {
  //             //LeftMenuActionCreators.getFacebookFolders();
  //             EditorActionCreators.SetPickerState("facebook");
  //           },
  //           { scope: "email,user_photos" }
  //         );
  //       } else {
  //         console.log("unkown status" + response.status);
  //         window.FB.login(
  //           function (response) {
  //             //LeftMenuActionCreators.getFacebookFolders();
  //             EditorActionCreators.SetPickerState("facebook");
  //           },
  //           { scope: "email,user_photos" }
  //         );
  //       }
  //     });
  //   } catch (error) {
  //     console.log("Something went wrong.");
  //   }
  // };

  const _dropboxClick = (event) => {
    <script
      type="text/javascript"
      src="https://www.dropbox.com/static/api/2/dropins.js"
      id="dropboxjs"
      data-app-key="f36rxxok4ds0q1c"
    ></script>;

    const onDropBoxReady = () => {
      const dropboxOptions = {
        // Required. Called when a user selects an item in the Chooser.
        success(files) {
          let fileUrl;
          if (files.length > 0) {
            for (let i = 0, len = files.length; i < len; i++) {
              fileUrl = files[i].link;
              window.editor.addPicture(fileUrl);
            }
          }
          EditorActionCreators.ShowFilePicker(false);
        },
        cancel() {
          // EditorActionCreators.ShowFilePicker(true);
        },
        linkType: "direct",
        // Optional. A value of false (default) limits selection to a single file, while
        // true enables multiple file selection.
        multiselect: false, // or true
        extensions: [".gif", ".jpg", ".jpeg", ".png"],
      };
      try {
        window.Dropbox.choose(dropboxOptions);
      } catch (error) {
        console.log("Something went wrong.");
      }
    };
    if (!document.getElementById("dropboxjs")) {
      let fileref = document.createElement("script");
      fileref.setAttribute("type", "text/javascript");
      fileref.setAttribute(
        "src",
        "https://www.dropbox.com/static/api/2/dropins.js"
      );
      fileref.setAttribute("id", "dropboxjs");
      fileref.setAttribute("data-app-key", "f36rxxok4ds0q1c");
      fileref.onload = onDropBoxReady;
      document.getElementsByTagName("head")[0].appendChild(fileref);
    } else {
      onDropBoxReady();
    }
  };

  const _onChange = () => {
    setStoresData(getStateFromStores());
  };

  const cutouts = useMemo(() => {
    if (
      LeftMenuStore.get() !== "init" &&
      EditorStore.getFilePickerTool() !== "cutout" &&
      EditorStore.getFilePickerTool() !== "design" &&
      EditorStore.getFilePickerTool() !== "collage" &&
      EditorStore.getFilePickerTool() !== "profile"
    ) {
      if (storesData.cutoutData && storesData.cutoutData?.length > 0) {
        return (
          <div
            className="filepicker-list-item clickable"
            data-id="cutouts"
            onClick={_cutoutClick}
          >
            <span className="icon">
              <svg viewBox="0 0 24.39 23.28">
                <g transform="matrix( 1, 0, 0, 1, -128.25,176.25) ">
                  <path
                    className="st0"
                    d="M132.06-167.22v0.05c0.15,1.18,0.68,2.23,1.6,3.15c0.46,0.46,0.98,0.83,1.55,1.1l-0.05,1c-3.4,1.63-5.7,4.4-6.9,8.3c-0.02,0.1-0.02,0.2,0,0.3c0.05,0.1,0.12,0.19,0.2,0.25c0.09,0.06,0.19,0.1,0.3,0.1h17.65c0.11,0,0.21-0.03,0.3-0.1c0.09-0.06,0.14-0.15,0.15-0.25c0.05-0.11,0.05-0.22,0-0.35c-1.08-3.15-2.55-5.48-4.4-7c-0.68-0.59-1.45-1.06-2.3-1.4l-0.1-1c0.42-0.22,0.84-0.54,1.25-0.95c0.63-0.62,1.06-1.34,1.3-2.15c0.13-0.33,0.21-0.67,0.25-1l-0.05,0.05c0.06-0.16,0.1-0.33,0.1-0.5v-0.85c0-0.02,0-0.06,0-0.1c-0.03-0.22-0.07-0.43-0.1-0.65c-0.01,0-0.02-0.02-0.05-0.05c-0.02-0.13-0.07-0.28-0.15-0.45c0.01,0,0.01-0.02,0-0.05c-0.29-0.69-0.72-1.34-1.3-1.95l0,0c-1.06-1.07-2.35-1.6-3.85-1.6c-1.47,0-2.74,0.53-3.8,1.6c-0.73,0.73-1.21,1.54-1.45,2.45c-0.07,0.25-0.1,0.51-0.1,0.8l-0.05,0.7C132.06-167.57,132.06-167.38,132.06-167.22 M133.11-168.47c0-0.18,0.02-0.35,0.05-0.5v-0.05c0.2-0.73,0.6-1.4,1.2-2c0.87-0.87,1.9-1.3,3.1-1.3c1.23,0,2.28,0.43,3.15,1.3h-0.05c0.5,0.51,0.87,1.06,1.1,1.65c0.02,0.03,0.04,0.05,0.05,0.05c0.05,0.12,0.09,0.22,0.1,0.3v-0.05c0.03,0.22,0.07,0.43,0.1,0.65v0.8c0,0.09-0.01,0.18-0.05,0.25c0.01,0.04,0.01,0.08,0,0.1c-0.03,0.27-0.1,0.53-0.2,0.8c-0.19,0.66-0.54,1.24-1.05,1.75c-0.41,0.41-0.84,0.69-1.3,0.85c-0.09,0.06-0.17,0.13-0.25,0.2c-0.04,0.1-0.05,0.2-0.05,0.3v0.1l0.2,1.6c0.01,0.09,0.04,0.18,0.1,0.25c0.06,0.08,0.13,0.13,0.2,0.15c0.86,0.33,1.63,0.78,2.3,1.35c1.59,1.34,2.87,3.32,3.85,5.95h-16.25c1.2-3.37,3.35-5.76,6.45-7.15c0.09-0.04,0.16-0.1,0.2-0.2c0.07-0.07,0.1-0.15,0.1-0.25l0.05-1.65c0-0.1-0.03-0.2-0.1-0.3c-0.04-0.06-0.11-0.11-0.2-0.15c-0.58-0.24-1.09-0.59-1.55-1.05c-0.75-0.75-1.18-1.6-1.3-2.55c0-0.15,0-0.32,0-0.5L133.11-168.47z"
                  />
                </g>
                <g transform="matrix( 1, 0, 0, 1, -128.25,176.25) ">
                  <path
                    className="st0"
                    d="M148.81-169.77c-0.2-0.17-0.42-0.32-0.65-0.45c-0.47,0.13-0.92,0.27-1.35,0.4c-0.23,0.03-0.28,0.12-0.15,0.25c0.03,0.07,0.03,0.13,0,0.2c-0.87,1.07-0.77,2.07,0.3,3l0.05,0.05c0.07,0.03,0.12,0.1,0.15,0.2h0.05c0.93,0.77,1.83,0.85,2.7,0.25c0.87-1,0.9-1.93,0.1-2.8c-0.27-0.3-0.58-0.6-0.95-0.9v0.05c-0.07-0.07-0.13-0.13-0.2-0.2C148.86-169.75,148.85-169.77,148.81-169.77 M148.76-168.57c0.07,0.1,0.13,0.17,0.2,0.2c0.07,0.07,0.12,0.13,0.15,0.2h0.05c0.23,0.23,0.38,0.47,0.45,0.7c0.03,0.2-0.03,0.42-0.2,0.65h0.05c-0.07,0.07-0.13,0.13-0.2,0.2c-0.03,0.03-0.07,0.07-0.1,0.1c-0.6,0.2-1.2-0.05-1.8-0.75c-0.3-0.37-0.4-0.73-0.3-1.1c0.13-0.13,0.25-0.27,0.35-0.4h0.05c0.4-0.23,0.82-0.17,1.25,0.2c0.03,0,0.05,0.02,0.05,0.05V-168.57 M138.46-174.97c-0.07-0.03-0.13-0.05-0.2-0.05c-0.33,0-0.65,0.1-0.95,0.3c0.13,0.07,0.28,0.15,0.45,0.25c1.27,0.8,2.55,1.6,3.85,2.4c0.03,0,0.08,0.02,0.15,0.05c0.07-0.03,0.12-0.05,0.15-0.05c1.03-0.37,2.07-0.48,3.1-0.35c-0.3-0.23-0.62-0.42-0.95-0.55L138.46-174.97 M152.16-176.22c-0.1,0.03-0.17,0.12-0.2,0.25c0,0.07-0.03,0.15-0.1,0.25c-0.27,0.6-0.65,0.82-1.15,0.65c-0.2-0.17-0.42-0.27-0.65-0.3c-0.63-0.17-1.27-0.08-1.9,0.25c-0.47,0.2-0.87,0.58-1.2,1.15c-0.2,0.33-0.27,0.65-0.2,0.95c0.1,0.33,0.17,0.65,0.2,0.95c-0.23,0.17-0.47,0.27-0.7,0.3c-0.7,0-1.38-0.03-2.05-0.1h-0.05c-0.1,0-0.22,0.02-0.35,0.05c-0.1,0.03-0.2,0.05-0.3,0.05c-1,0.17-2,0.43-3,0.8c-1.03,0.33-2.05,0.67-3.05,1h-0.05c-0.2,0.1-0.4,0.18-0.6,0.25c0.17,0.27,0.38,0.42,0.65,0.45c1.17,0.07,2.3,0.07,3.4,0c0.97-0.07,1.92-0.18,2.85-0.35c0.67-0.1,1.3-0.27,1.9-0.5c0.63-0.23,1.27-0.43,1.9-0.6c1.1-0.3,2.18-0.82,3.25-1.55c0.5-0.57,0.72-1.1,0.65-1.6v-0.05c0.03-0.03,0.08-0.1,0.15-0.2v0.05c0.07-0.07,0.13-0.12,0.2-0.15c0.77-0.6,1.03-1.23,0.8-1.9h-0.05C152.38-176.25,152.26-176.28,152.16-176.22 M149.96-174.47c0.5,0.4,0.6,0.83,0.3,1.3c-0.03,0.07-0.08,0.13-0.15,0.2v-0.05l-0.05,0.05c-0.03,0.03-0.07,0.08-0.1,0.15c-0.53,0.37-1.1,0.53-1.7,0.5c-0.53-0.33-0.68-0.75-0.45-1.25c0.1-0.23,0.25-0.42,0.45-0.55C148.8-174.45,149.36-174.57,149.96-174.47 M145.66-171.32c0.07-0.13,0.17-0.2,0.3-0.2s0.25,0.07,0.35,0.2c0.07,0.07,0.1,0.17,0.1,0.3c0,0.1-0.03,0.2-0.1,0.3c-0.1,0.1-0.22,0.15-0.35,0.15s-0.23-0.05-0.3-0.15c-0.1-0.1-0.15-0.2-0.15-0.3C145.51-171.15,145.56-171.25,145.66-171.32z"
                  />
                </g>
              </svg>
            </span>
            <span className="name">Your Cutouts</span>
          </div>
        );
      }
    }
  }, [EditorStore.getFilePickerTool(), LeftMenuStore.get()]);

  const myAssets = useMemo(() => {
    if (
      storesData.projectAssetData &&
      storesData.projectAssetData?.length > 0
    ) {
      return (
        <div
          className="filepicker-list-item clickable"
          data-id="assets"
          onClick={_assetsClick}
        >
          <span className="icon">
            <UploadedImage />
          </span>
          <span className="name">Uploaded Images</span>
        </div>
      );
    }
  }, [storesData.projectAssetData]);

  const cancelButton = useMemo(() => {
    if (LeftMenuStore.get() !== "init") {
      return (
        <div className="close-btn" onClick={_cancelClick}>
          <CloseSVG height={12} />
        </div>
      );
    } else {
      return (
        <Link to="/app/start" id="filepicker-cancel-btn" className="close-btn">
          <CloseSVG height={12} />
        </Link>
      );
    }
  }, [LeftMenuStore.get()]);

  return (
    <div className="filepicker">
      <div id="filepicker-dialog" className="filepicker-dialog active">
        <div className="filepicker-dialog-box">
          <div className="picker-title">
            <div className="filepicker-title">Select Image Source</div>
            {cancelButton}
          </div>

          <div id="filepicker-sources-list" className="filepicker-list">
            <div
              className="filepicker-list-item clickable"
              data-id="computer"
              onClick={_computerClick}
            >
              <svg
                className="icon"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 719.4 668.3"
                enableBackground="new 0 0 719.4 668.3"
                height={20}
              >
                <g transform="matrix( 1, 0, 0, 1, 0,0) ">
                  <g>
                    <g id="Layer0_0_FILL">
                      <path
                        className="st0"
                        fill="#FFFFFF"
                        d="M481,59.8L481,59.8C440.4,20,391.3,0,333.8,0c-57.5,0-106.6,20-147.3,59.8v0c-40.2,39.5-60.6,87-61.2,142.5
				c-25.1,9.4-47.9,24.4-68.3,44.9C19,285.1,0,330.9,0,384.5c0,53.6,19,99.4,56.9,137.3c37.9,37.9,83.7,56.9,137.3,56.9
				c21.8,0,42.3-3.1,61.5-9.4c-0.1-20-0.5-40-1.2-60c-18.2,8.9-38.3,13.4-60.3,13.4c-38.2,0-70.8-13.5-97.8-40.5
				c-27-27-40.5-59.5-40.5-97.7c0-38.2,13.5-70.8,40.5-97.8c25.7-25.6,56.4-39.1,92.2-40.3c-1-4.6-2.1-9.8-3.1-15.6
				c-2.1-11.5-3.2-20.1-3.2-25.9c0-40.7,14.8-75.5,44.1-104.4h0.1c29.6-29,65.3-43.5,107.2-43.5c41.9,0,77.6,14.5,107.2,43.5
				c29.4,28.9,44.1,63.7,44.2,104.4c0,11.1-1.1,21.8-3.3,32c-0.3,0.6-1,3-2.2,7.4c-1.2,4.2-1.8,6.5-1.9,7.1c0,0.3-0.1,0.6-0.2,0.9
				c14.1-4.5,29.1-6.8,45-6.8c36.6,0,68.1,11.9,94.6,35.6c1.7,1.5,3.5,3.1,5.1,4.8c27.3,26.8,41,59.2,41.1,97.1
				c0,37.9-13.7,70.2-41.1,97h0c-27.5,27-60.7,40.5-99.7,40.5c-19.3,0-37.2-3.3-53.8-10l-0.7,58.9c17.2,4.7,35.3,7,54.4,7
				c54.3,0,100.6-18.9,139-56.5v0c38.6-37.8,57.9-83.4,57.8-137c0-53.5-19.3-99.2-57.8-137.1c-24.2-23.7-51.5-40-82-48.8
				c-3-0.8-6-1.6-9.1-2.4c-9.3-2.2-18.8-3.7-28.7-4.5C538.6,139.9,518.3,96.4,481,59.8 M366.1,292.3c-0.4,0-0.7,0-1.1,0
				c-6,0.4-11.7,2.6-17.1,6.9c-0.3,0.2-0.5,0.5-0.8,0.7L233.8,413.6c-0.8,0.8-1.4,1.8-1.9,2.9c-5.2,14.4-3.5,25.1,5.1,32
				c0.1,0,0.1,0.1,0.1,0.1c10.7,9,21.4,10,32.1,3c0.5-0.3,1-0.7,1.4-1.1l66.5-66.8v260c0,1,0.2,2,0.5,2.9
				c5.8,14.9,14.8,22.1,26.9,21.7h1.9c6.2,0,11.7-2,16.5-6.2c4.2-3.5,7.7-8.6,10.4-15.5c0.4-0.9,0.6-1.9,0.5-2.9v-260l66.4,66.8
				c0.5,0.4,0.9,0.8,1.4,1.1c10.8,6.9,21.5,5.9,32.1-3.1c0.1,0,0.1-0.1,0.2-0.1c8.6-6.9,10.3-17.5,5-32c-0.4-1.1-1-2.1-1.8-2.9
				L384,299.9c-0.3-0.3-0.6-0.6-1-0.9C377.1,294.9,371.5,292.7,366.1,292.3z"
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <span className="name">Upload from Computer</span>
            </div>
            {cutouts}
            <div
              className="filepicker-list-item clickable"
              data-id="backgrounds"
              onClick={_backgroundClick}
            >
              <UploadsImage />
              <span className="name">Stock Images & Backgrounds</span>
            </div>
            <div
              className="filepicker-list-item clickable"
              data-id="backgrounds"
              onClick={AIClick}
            >
              <AIImage />
              <span className="name">Magic A.I. Image Maker</span>
            </div>
            {myAssets}
            <div
              className="filepicker-list-item clickable"
              data-id="dropbox"
              onClick={_dropboxClick}
            >
              <DropboxImage className="icon" height={20} />
              <span className="name">Dropbox</span>
            </div>
          </div>

          <div id="filepicker-dialog-loading" className="filepicker-loading">
            Loading…
          </div>
          <input
            type="file"
            name="s_files"
            id="s_files"
            multiple
            accept="image/*, .pizap"
          />
          <input
            type="file"
            name="s_file"
            id="s_file"
            accept="image/*, .pizap"
          />
        </div>
      </div>
    </div>
  );
};

export default PickerMenu;
